import { render, staticRenderFns } from "./MyWay.vue?vue&type=template&id=43d9e117&"
import script from "./MyWay.vue?vue&type=script&lang=js&"
export * from "./MyWay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports